<div class="star-rating">
  @for(star of stars; track $index){
  <span class="star" [class.checked]="star <= checkedStars" (click)="onStarClick(star)">
    &#9733;
  </span>
  }
</div>